module.exports = __webpack_public_path__ + "img/cart-outline.9d9337e.svg";